import { render, staticRenderFns } from "./wsSidebarParticipants.vue?vue&type=template&id=b4bdc4c6&scoped=true&"
import script from "./wsSidebarParticipants.vue?vue&type=script&lang=js&"
export * from "./wsSidebarParticipants.vue?vue&type=script&lang=js&"
import style0 from "./wsSidebarParticipants.vue?vue&type=style&index=0&id=b4bdc4c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bdc4c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VHover,VIcon,VSheet})
